import { useChat } from '@agently/components/chat-core';

const Chat = () => {
  const { unread } = useChat();
  if (!unread) return null;
  return (
    <div className="rounded-full absolute top-0 right-3 bg-red-400 text-white text-xs size-4 grid place-content-center">
      {unread}
    </div>
  );
};

export default Chat;
